import { MenuGroup, Section } from '@atlaskit/menu';
import { Box } from '@atlaskit/primitives';
import { type OpenThreadContextData } from '@databases/comments/context/CommentContext';
import { type DialogContextInterface } from '@databases/dialog';
import React from 'react';

import { type MenuContentItemFactory } from '../select-value-menu/types';

import { buildMenuSections } from './build-menu-sections';

export interface ContextMenuContentProps {
  items: MenuContentItemFactory[];
  showDialog: DialogContextInterface['showDialog'];
  setOpenThread: (value: OpenThreadContextData) => void;
}

export const ContextMenuContent: React.FC<ContextMenuContentProps> = ({
  items,
  showDialog,
  setOpenThread,
}) => {
  const sections = buildMenuSections(items, showDialog, setOpenThread);

  return (
    <Box paddingBlock="space.050">
      <MenuGroup testId="database-context-menu" minWidth="242px">
        {sections.map((section, index) => (
          <Section key={`section-${index}`} hasSeparator={section.hasSeparator}>
            {section.items}
          </Section>
        ))}
      </MenuGroup>
    </Box>
  );
};
